import {
	ICompaniesStructure,
	ICompanyStructure,
} from '../../forms/components/company-structure/ICompanyStructure';
import { PayloadAction } from '@reduxjs/toolkit';

export const CompanySubQuestionReducer = {
	addMultipleCompanies: (
		state: ICompaniesStructure,
		action: PayloadAction<ICompanyStructure[]>
	) => {
		state.list = action.payload;
	},
	addCompany: (
		state: ICompaniesStructure,
		action: PayloadAction<ICompanyStructure>
	) => {
		const clone = [...state.list];
		clone.push(action.payload);
		state.list = clone;
	},
	deleteCompany: (
		state: ICompaniesStructure,
		action: PayloadAction<string>
	) => {
		state.list = state.list.filter(
			(item: ICompanyStructure) => item.id !== action.payload
		);
	},
	editCompany: (
		state: ICompaniesStructure,
		action: PayloadAction<ICompanyStructure>
	) => {
		state.list = state.list.map((item: ICompanyStructure) => {
			if (item.id === action.payload.id) {
				return {
					...action.payload,
				};
			} else {
				return item;
			}
		});
	},
};
